import { Component, OnInit } from '@angular/core';
import { Dashboard, MapLayerItem, TransformDetail, Widget } from 'src/api/models';
import { DataService, FileService } from 'src/api/services';
import { IconService } from 'src/service/icon.service';
import { IWidgetEditor, WidgetType, ChartWidget } from "src/app/models/dashboard";
import { StorageTablesService } from "src/service/storage-tables.service";
import { ApplicationConfigService } from 'src/service/application-config.service';
import { MapLayerTableService } from 'src/service/map-layer.service';
import { map } from 'rxjs';

@Component({
    selector: "app-telemetry-map-widget-editor",
    templateUrl: "./telemetry-map-widget-editor.component.html",
    styleUrls: ["./telemetry-map-widget-editor.component.css"],
})


export class TelemetryMapWidgetEditorComponent implements OnInit, IWidgetEditor {
    public widgetType: WidgetType;

    public widget: TelemetryMapWidgetModel;
    public w: TelemetryMapWidgetModel;

    public dashboard: Dashboard;

    public transformList: TransformDetail[];
    private colours: string[];

    public showMenu: boolean;

    public pins: any[];
    public geoJsonLayers: MapLayerItem[];
    public allMapLayers: MapLayerItem[];
    public selectedLayerId: number | null = null;
    public layersLoaded: boolean = false;

    public selectedPin: any;
    public popupHelp: string = 'Use Handlebars syntax/html to create custom popups. Available variables: data (value), latitude, longitude, pointMetaData (point metadata), metaData (Series metadata). Example: {{data}}';

    constructor(public fileService: FileService,
        public storageTablesService: StorageTablesService,
        public iconService: IconService,
        public app: ApplicationConfigService,
        public layerService: MapLayerTableService) {
        this.colours = [
            '#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
            '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
            "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
            "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
        ];



    }

    private newEventType: string;

    ngOnInit() {
        this.allMapLayers = [];
        this.geoJsonLayers = [];
        this.layerService.get();

        this.layerService.remoteData.subscribe(layers => {
            if (!layers) {
                this.allMapLayers = [];
                this.geoJsonLayers = [];
                this.layersLoaded = true; // Mark as loaded even if empty
                return;
            }
            
            // Store all layers
            this.allMapLayers = layers;
            
            // Filter for GeoJSON layers
            this.geoJsonLayers = layers.filter(layer => layer.layerType.toLowerCase() === 'geojson');
            
            // Mark layers as loaded
            this.layersLoaded = true;
            
            // Update temp layer flags for all tabs
            this.updateTempLayerFlags();
        });

        if (this.widget.timeSeriesDetailList == null) {
            this.widget.timeSeriesDetailList = [];
        }
        // Initialize showGroupByDefault and groupInLegend for existing tabs
        this.widget.timeSeriesDetailList.forEach(tab => {
            if (tab.showGroupByDefault === undefined) {
                tab.showGroupByDefault = true;
            }
            if (tab.groupInLegend === undefined) {
                tab.groupInLegend = true;
            }
        });
        if (this.widget.layers == null) {
            this.widget.layers = [];
        }
        this.w = this.widget;
        
        // Initialize temp layer flags after view initialization to avoid change detection errors
        setTimeout(() => this.updateTempLayerFlags(), 0);

        this.pins = []
        this.iconService.getPins(tpins => {
            //this.pins = [];
            for (var key in tpins) {
                var pin = tpins[key].options as any;
                pin.key = key;
                this.pins.push(pin);
            }
        });

        
    }

    public addTimeSeries() {
        this.w.timeSeriesDetailList.push({
            uri: "",
            axis: 0,

            style: "solid",

            customTooltip: false,
            customTooltipTags: [{ metaTag: "", displayName: "" }],

            active: true,
            removable: true,
            colour: this.colours[this.w.timeSeriesDetailList.length],
            transforms: [],

            displayType: "fixed",
            gradientStops: [],
            gradientRangeMin: -20,
            gradientRangeMax: 50,
            renderType: "pin",

            useGradient: false,
            pinKey: "blue",
            geoJsonLayer: null,

            useMetaTag: false,
            valueMetaTag: "",

            showPopups: false,
            popupHTML: "",
            showToolTips: true,

            hideLayer: false,
            hideRules: [],

            showGroupByDefault: true,
            groupInLegend: true,

            defaultPinName: "Default"

        });
    }

    public addLayer() {
        if (!this.selectedLayerId) {
            return;
        }
        
        // Convert to number (select returns string)
        const layerId = Number(this.selectedLayerId);
        
        // Check if layer is already added
        if (this.w.layers.some(l => l.mapLayerId === layerId)) {
            alert('This layer is already added');
            return;
        }
        
        // Only store mapLayerId and active state
        this.w.layers.push({
            mapLayerId: layerId,
            active: true
        });
        
        // Reset selection
        this.selectedLayerId = null;
    }

    public removeLayer(layer: { mapLayerId: number; active: boolean }) {
        const index = this.w.layers.indexOf(layer);
        if (index > -1) {
            this.w.layers.splice(index, 1);
        }
    }

    // Helper method to get full layer details by ID
    public getLayerDetails(mapLayerId: number): MapLayerItem | undefined {
        return this.allMapLayers.find(l => l.mapLayerId === mapLayerId);
    }

    public addTracker() {
        // this.w.timeSeriesDetailList.push({
        //   uri: " ",
        //   axis: 0,
        //   transform: "tracker",
        //   type: "tracker",
        //   style: "solid",
        //   showMarker: false,
        //   size: 1,
        //   active: true,
        //   removable: true,
        //   colour: this.colours[this.w.timeSeriesDetailList.length],
        //   transforms: []
        // });
    }

    public addGeoJson() {
        // this.w.timeSeriesDetailList.push({
        //   uri: " ",
        //   axis: 0,
        //   type: "geojson",
        //   style: "solid",
        //   showMarker: false,
        //   size: 1,
        //   active: true,
        //   removable: true,
        //   colour: this.colours[this.w.timeSeriesDetailList.length],
        //   transforms: []
        // });
    }

    public addHeatmap() {
        // this.w.timeSeriesDetailList.push({
        //   uri: " ",
        //   axis: 0,
        //   type: "heatmap",
        //   style: "solid",
        //   showMarker: false,
        //   size: 1,
        //   weight:100,
        //   active: true,
        //   removable: true,
        //   colour: this.colours[this.w.timeSeriesDetailList.length],
        //   transforms: [],
        //   useRssi: false,
        // });
    }

    public addFixed() {
        // this.w.timeSeriesDetailList.push({
        //   uri: " ",
        //   axis: 0,
        //   transform: null,
        //   type: "fixed",
        //   style: "solid",
        //   showMarker: false,
        //   size: 1,
        //   popupHeight: 150,
        //   active: true,
        //   removable: true,
        //   colour: this.colours[this.w.timeSeriesDetailList.length],
        //   transforms: []
        // });
    }

    public removeTimeSeries(timeSeries: any): void {
        const index = this.w.timeSeriesDetailList.indexOf(timeSeries);
        if (index > -1) {
            this.w.timeSeriesDetailList.splice(index, 1);
        }
    }

    public duplicateTimeSeries(timeSeries: any): void {
        // Deep clone the time series object
        const clonedTimeSeries = JSON.parse(JSON.stringify(timeSeries));
        
        // Update display name to indicate it's a copy
        if (clonedTimeSeries.displayName) {
            clonedTimeSeries.displayName = clonedTimeSeries.displayName + ' (Copy)';
        }
        
        // Add the cloned time series to the list
        this.w.timeSeriesDetailList.push(clonedTimeSeries);
    }

    updateWidget(tab, selected) {

    }

    addNewEvent(tab) {
        // if (tab.events == null){
        //   tab.events = [];
        // }
        // if (this.newEventType == 'pin'){
        //   tab.events.push({
        //     type:this.newEventType,
        //     pin: 'blue'
        //   });
        // }
        // else if (this.newEventType == 'display'){
        //   tab.events.push({
        //     type:this.newEventType,
        //   });
        // }    
        // else if (this.newEventType == 'geojson'){
        //   tab.events.push({
        //     type:this.newEventType,
        //   });
        // }
    }

    removeEvent(tab, event) {
        // const index = tab.events.indexOf(event, 0);
        // if (index > -1) {
        //   tab.events.splice(index, 1);
        // }
    }

    selectPin(event, pin) {
        // event.pin = pin.key;
        // this.showMenu = false;  
        this.selectedPin = pin;
        // console.log("Selected pin:", pin);
    }

    selectPinForRule(rule, pin) {
        rule.pinName = pin.key;
        rule.showMenu = false;
    }

    getPin(key) {
        if (!key || !this.pins) {
            return null;
        }
        return this.pins.find(p => p.key === key);
    }

    // Update the temp layer flags for all time series tabs
    private updateTempLayerFlags(): void {
        if (!this.w?.timeSeriesDetailList) {
            return;
        }
        
        this.w.timeSeriesDetailList.forEach((tab, idx) => {
            if (tab.geoJsonLayer) {
                // Check if the saved layer exists in the loaded list
                const found = this.geoJsonLayers.find(l => l.layerName === tab.geoJsonLayer);
                tab.showTempLayerOption = !found;
            } else {
                tab.showTempLayerOption = false;
            }
        });
    }

    addHideRule(tab) {
        for(const ts of this.w.timeSeriesDetailList)
        {
            if(ts == tab)
            {
                if(!ts.hideRules)
                {
                    ts.hideRules = [];
                }

                ts.hideRules.push({
                    operator: 'lessThan', 
                    value: 0, 
                    metaTag: '', 
                    hideType: 'hide', 
                    pinName: null,
                    index: ts.hideRules.length,
                    showMenu: false,
                    label: ''
                });
            }
        }
    }

    removeHideRule(tab, index: number) {
        if (index >= 0 && index < tab.hideRules.length) {
            tab.hideRules.splice(index, 1);
            this.updateRuleIndices(tab);
        }
    }

    moveRuleUp(tab, index: number) {
        if (index > 0) {
            const rule = tab.hideRules[index];
            tab.hideRules.splice(index, 1);
            tab.hideRules.splice(index - 1, 0, rule);
            this.updateRuleIndices(tab);
        }
    }

    moveRuleDown(tab, index: number) {
        if (index < tab.hideRules.length - 1) {
            const rule = tab.hideRules[index];
            tab.hideRules.splice(index, 1);
            tab.hideRules.splice(index + 1, 0, rule);
            this.updateRuleIndices(tab);
        }
    }

    private updateRuleIndices(tab) {
        tab.hideRules.forEach((rule, idx) => {
            rule.index = idx;
        });
    }

    public uploadShapeFile(rule, fileObj) {
        // const file = fileObj.item(0);

        // //todo: read file in and post to API to store as file in Azure Storage
        // if(!window.FileReader) return; // Browser is not compatible
        // var reader = new FileReader();
        // var uploadFile = (d) => {
        //   /*this.fileService.FileUpload({
        //     shareType:"dashboard",
        //     customerId:this.app.customerId,
        //     fileIdentifier:file.name,
        //     itemId:this.dashboard.dashboardId.toString(),
        //     file: d
        //   }).subscribe(r => {
        //     rule.geoJsonUri = r;
        //   }, error => {
        //     console.error(error);
        //   });*/
        //   rule.geoJson = d;
        // };

        // reader.onloadend = function(evt) {
        //   if(evt.target.readyState != 2) return;
        //   if(evt.target.error) {
        //       alert('Error while reading file');
        //       return;
        //   }
        //   uploadFile(reader.result);
        // };
        // reader.readAsDataURL(file);
    }
}

export interface TelemetryMapWidgetModel extends Widget {
    //timeSeriesDetailList: TransformDetail[];
    timeSeriesDetailList?: any[];
    layers: { mapLayerId: number; active: boolean }[] | null;
    centerLatitude: number;
    centerLongitude: number;
    zoomLevel: number;
    mapType: 'open' | 'terrain' | 'streets' | 'satellite';
}
// export interface TelemetryMayWidgetLayerModel {
//     name: string;
//     onByDefault: boolean;
//     type: 'tracker' | 'telemetry' | 'mapLayer';

// }
